import React from 'react'
import ArrowIcon from '../../assets/arrow-icon.svg'

const AddSection = ({ openAdd }) => {
  return (
    <div
      style={{ zIndex: 25 }}
      className="absolute -bottom-4 w-full flex justify-center"
      onClick={openAdd}
    >
      <button
        className={`border-0 bg-[#2172eb] text-white md:px-2 md:py-1 text-sm rounded-md flex items-center`}
      >
        ADD SECTION
        <img src={ArrowIcon} className="md:mx-2 md:w-3 md:h-3" alt="arrow" />
      </button>
    </div>
  )
}

export default AddSection
